var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.375V23.625C0 25.4869 1.51088 27 3.375 27H14.625C16.4886 27 18 25.4869 18 23.625V22.2188C18 21.4425 17.3706 20.8125 16.5938 20.8125C15.8169 20.8125 15.1875 21.4425 15.1875 22.2188V23.625C15.1875 23.9344 14.9344 24.1875 14.625 24.1875H3.375C3.06562 24.1875 2.8125 23.9344 2.8125 23.625V3.375C2.8125 3.06562 3.06562 2.8125 3.375 2.8125H14.625C14.9344 2.8125 15.1875 3.06562 15.1875 3.375V4.78125C15.1875 5.5575 15.8169 6.1875 16.5938 6.1875C17.3706 6.1875 18 5.5575 18 4.78125V3.375C18 1.51313 16.4886 0 14.625 0H3.375C1.51088 0 0 1.51313 0 3.375Z",
    fill: "#7C7C7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9215 14.2927L15.714 18.5058C15.0058 19.2145 13.7902 18.7139 13.7902 17.7127V15.7495H8.20459C7.58359 15.7495 7.07959 15.2489 7.07959 14.6245V12.3745C7.07959 11.7558 7.58359 11.2495 8.20459 11.2495H13.7902V9.2864C13.7902 8.28515 15.0058 7.78453 15.714 8.49328L19.9215 12.7064C20.3591 13.1452 20.3591 13.8539 19.9215 14.2927Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.64c2ffe7.svg";
export { ForwardRef as ReactComponent };